import React from "react";
import { InputGroup, Button, Input } from "reactstrap";
import IconReset from "../../src/assets/images/icon__times.svg";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <InputGroup>
      <Input
        id="search"
        type="text"
        placeholder="Search..."
        value={filterText}
        onChange={onFilter}
        className="form-search"
      />
      {(!!filterText && (
        <span onClick={onClear} role="button" className="form-search-reset">
          <img src={IconReset} alt="" />
        </span>
      )) ||
        null}
    </InputGroup>
  </>
);

export default FilterComponent;
